import { createContext } from 'react';

export const ListFilterContext = createContext({});

export const ListFilterProvider = ListFilterContext.Provider;
export const ListFilterConsumer = ListFilterContext.Consumer;
